<div class="custom-container">
  <div class="row justify-content-center">
    <div class="pl-6 col-md-6 align-content-center">
      <div class="wrapper">
        <div class="card-body">
          <img src="./assets/images/logo-default.png" class="logo" alt="Logo" />
          <h5 class="card-title text-left">
            Esqueceu a senha? Basta digitar seu e-mail abaixo que enviaremos o
            passo a passo da redefinição no seu e-mail.
          </h5>
          <form
            [formGroup]="form"
            class="d-flex flex-column align-items-center"
          >
            <div class="w-100">
              <div class="email-input d-flex align-items-baseline mt-4">
                <input
                  class="form-input"
                  type="email"
                  id="inputEmail"
                  name="email"
                  placeholder="Digite seu e-mail"
                  (keydown.enter)="onSubmit()"
                  formControlName="email"
                />
              </div>

              <button
                type="button"
                class="btn btn-no-auth"
                (click)="onSubmit()"
                [disabled]="form.invalid"
              >
                Confirmar
              </button>

              <button
                routerLink="/login"
                type="button"
                class="btn btn-no-auth"
              >
                Fazer login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="col-md-6 slider">
      <app-slider></app-slider>
    </div>
  </div>
</div>
